export default __webpack_public_path__ + "static/media/brand-arrow.b4183480.png";